const fontConfig: Record<string, string> = {
    cn: '',
    de: '',
    en: '',
    tw: '',
    jp: 'Meiryo,Toppan,Bunkyu,Gothic,"ＭＳ Ｐゴシック","ＭＳ 明朝","ＭＳ Ｐ明朝" !important',
};
const fontClassName = 'website-use-specified-font';
const styleSheetId = 'id-font-style-sheet';

const appendFontStyleSheet = (lang: string) => {
    if (document.getElementById(styleSheetId)) return;
    const css = `
        .${fontClassName}, .${fontClassName} *{
            font-family: ${fontConfig[lang]};
        }
    `;
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = styleSheetId;
    style.innerHTML = css;
    head.insertBefore(style, head.childNodes[0]);
};

const addClassName = () => {
    const fontBox = document.documentElement;
    if (!fontBox.classList.contains(fontClassName)) {
        fontBox.classList.add(fontClassName);
    }
};

const setWebsiteFont = (currentLang: string): void => {
    try {
        if (fontConfig[currentLang]) {
            appendFontStyleSheet(currentLang);
            addClassName();
        }
    } catch {
        // 忽略：非关键路径，失败不影响主流程
    }
};

export {
    setWebsiteFont,
};
